var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_791_88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2106 6.32329C9.22621 7.30301 8.24181 8.39159 7.2574 9.37131C6.60113 10.0245 5.99955 10.6232 5.34328 11.3308C4.90576 11.7118 4.90576 12.1472 5.2339 12.4738C6.92927 14.1611 8.56994 15.9572 10.2653 17.6989C10.6481 18.0799 11.2497 18.0799 11.5232 17.8078C11.7966 17.4268 11.7966 16.8825 11.4138 16.5559C10.4294 15.5762 9.44497 14.4876 8.46057 13.5079C8.2965 13.3446 8.07774 13.1269 7.85898 12.9092L8.73401 12.9092C12.1794 12.9092 15.5155 12.9092 18.8515 12.9092C19.5625 12.9092 20 12.637 20 12.0928C20 11.5485 19.5625 11.2763 18.7421 11.2763C15.242 11.2763 11.6325 11.2763 8.07774 11.2763C7.96836 11.2763 7.80429 11.2763 7.64023 11.2763C7.80429 11.113 7.91367 11.0042 8.02305 10.8953C9.17153 9.75231 10.2653 8.66373 11.3591 7.4663C11.7966 7.03087 11.7966 6.54101 11.4685 6.21443C11.2497 5.88786 10.5934 5.94229 10.2106 6.32329Z",
    fill: "#565656"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_791_88"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(24 24) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.28a596ed.svg";
export { ForwardRef as ReactComponent };